import type { IconPrefix } from '@fortawesome/pro-solid-svg-icons'
import React, { memo } from 'react'
import styled from 'styled-components'

import type { Variant } from '../../../themes/types/commons.type'
import { Stack } from '../../layout'
import { Card } from '../../surfaces'
import Button from '../Button/Button'
import type { IconName } from '../Icon/Icon'
import Icon from '../Icon/Icon'
import Text from '../Text/Text'

export interface EmptyStateProps {
  'data-e2e'?: string
  buttonDisabled?: boolean
  buttonLabel?: string
  className?: string
  icon: IconName
  iconStyle?: IconPrefix
  iconVariant?: Variant
  onClick?: () => void
  primaryText: string
  secondaryText?: string
}

const CenteredText = styled(Text)`
  text-align: center;
`

const EmptyState = ({
  'data-e2e': dataE2e,
  buttonDisabled,
  buttonLabel,
  className,
  icon,
  iconStyle = 'fas',
  iconVariant = 'neutral',
  onClick,
  primaryText,
  secondaryText,
}: EmptyStateProps) => (
  <Card className={className} data-e2e={dataE2e} spacing="medium">
    <Stack alignment="center" spacing="medium" inline fullWidth>
      <Icon name={icon} faStyle={iconStyle} size="4x" variant={iconVariant} />

      <Text bold variant="secondary" size="large">
        {primaryText}
      </Text>

      {secondaryText && <CenteredText variant="neutral">{secondaryText}</CenteredText>}

      {onClick && (
        <Button
          data-e2e={dataE2e ? `${dataE2e}--cta` : undefined}
          disabled={buttonDisabled}
          onClick={onClick}
          variant="primary"
        >
          {buttonLabel}
        </Button>
      )}
    </Stack>
  </Card>
)

export default memo(EmptyState)
